export const FILE_LIMITATION = 10000000;

let baseUrl: string = "";
export const setBaseUrl = (value: string) => {
  baseUrl = value;
  console.log("saveulr", value);
};
export const API_URL = () => {
  if (baseUrl) return baseUrl;
  return "";
  // return process.env.REACT_APP_API_URL;
};

export const SOCKETS_URL = () => {
  if (baseUrl) return baseUrl + "signalr/notification/hub";
  return process.env.REACT_APP_SOKETS_URL;
};

export const AUTH_URL = () => {
  return process.env.REACT_APP_AUTH_URL;
};

export const APP_ID = "EAB5764C-09A9-4C4A-B44A-473DF724EE1D";
